<template>
	<div class="tpl gift-exchange-wrap">
		<mt-header title="礼物真实兑换" fixed>
			<router-link :to="{name:'my-gifts'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right" @click.native="showAlert=1">兑换须知</mt-button>
		</mt-header>
		<div class="top-banner">
			<img src="../../assets/img/mine/center_gift_banner_99.png" alt="">
		</div>
		<div class="form-wrap">
			<p class="title">兑换信息填写</p>
			<div class="form-list">
				<ul>
					<li>
						<span class="name">兑换数量</span>
						<span class="value">
							<span class="add" @click="addNum"><img src="../../assets/img/mine/center_gift_ic_add.png" alt=""></span>
						<input class="nums" type="number" v-model="exchangeNum">
						<span class="add" @click="delNum"><img src="../../assets/img/mine/center_gift_ic_little.png" alt=""></span>
						</span>
					</li>
					<li>
						<span class="name">联系人</span>
						<span class="value">
							<input type="text" placeholder="填写收货人姓名" v-model="contactName">
						</span>
					</li>
					<li>
						<span class="name">联系电话</span>
						<span class="value">
							<input type="tel" placeholder="填写收货人手机号" v-model="contactTel">
						</span>
					</li>
					<li>
						<span class="name">选择地址</span>
						<div class="add value">
							<div>
								<input readonly type="text" placeholder="选择省" @click="showProv" v-model="addressName.provName">
								<div class="add-list" v-if="showAdd.prov">
									<p v-for="item in addList.provList" @click="chooseAdd(item.region_id,item.region_name,1)">{{item.region_name}}</p>
								</div>
							</div>
							<div>
								<input readonly type="text" placeholder="选择市" @click="showCity" v-model="addressName.cityName">
								<div class="add-list" v-if="showAdd.city">
									<p v-for="item in addList.cityList" @click="chooseAdd(item.region_id,item.region_name,2)">{{item.region_name}}</p>
								</div>
							</div>
							<div>
								<input readonly type="text" placeholder="选择区" @click="showArea" v-model="addressName.areaName">
								<div class="add-list" v-if="showAdd.area">
									<p v-for="item in addList.areaList" @click="chooseAdd(item.region_id,item.region_name,3)">{{item.region_name}}</p>
								</div>
							</div>
						</div>
					</li>
					<li>
						<span class="name">详细地址</span>
						<span class="value">
							<input type="text" placeholder="填写详细收货地址" v-model="detailAddress">
						</span>
					</li>
					<li>
						<span class="name">备注</span>
						<span class="value">
							<textarea placeholder="关于订单的额外备注信息，请在此处留言。" v-model="remakes"></textarea>
						</span>
					</li>
					<li>
						<span class="name">设为默认地址</span>
						<span class="value">
							<mt-switch v-model="setAddress"></mt-switch>
						</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="form-submit">
			<div class="form-price">
				<p>快递费： <span class="num">{{transFee}}</span><span class="num-name">桃花币</span></p>
			</div>
			<div class="form-btn">
				<button @click="submitExchange">立即兑换</button>
			</div>
		</div>
		<common-alert v-if="showAlert" @hideAlert="hideAlert">
			<p slot="title" class="title">{{alertInfo.title}}</p>
			<div class="content" slot="content" v-html="alertInfo.text"></div>
		</common-alert>
	</div>
</template>

<script>
	import CommonAlert from "../Common/CommonAlert"
	export default {
		name: "gift-exchange",
		components:{
			CommonAlert,
		},
		data() {
			return {
				uid: "",
				gid: "", //礼物id
				aid: "", //地址表id
				maxNum: "", //可兑换的最大数量
				giftType: "", //礼物type
				exchangeNum: 1, //兑换的数量
				contactName: "",
				contactTel: "",
				provId: "",
				cityId: "",
				areaId: "",
				addressName: {
					provName: "",
					cityName: "",
					areaName: "",
				},
				showAdd: {
					prov: 0,
					city: 0,
					area: 0,
				},
				addList: {
					provList: [],
					cityList: [],
					areaList: [],
				},
				detailAddress: "",
				remakes: "", //备注
				setAddress: false, //是否设置为默认地址
				preName: "",
				preTel: "",
				preArea: "", //表中读到的区的名称，用于判断是否改变
				preDetailAdd: "",
				transFee: 0,
				showAlert:0,
				alertInfo:{
					title:"兑换须知？",
					text:"<p>&nbsp;1.兑换须知：虚拟礼物可兑换实物，兑换实物则不可兑现。<br/>2.兑换流程：点击礼物，进入兑换操作页面，根据系统提示操作即可。<br/>3.注意事项：兑换的礼物真是有效，将会通过快递送达（江浙沪包邮，其他地区邮费自理）。<br/>4.自兑换起，48小时内为您发货，如遇特殊情况可能会有延迟。<br/>5.快递寄出礼物非质量问题，暂不支持退换。&nbsp;</p>"
				},
			}
		},
		created() {
			console.log(this.$route.query)
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);

			this.gid = this.$route.query.gid;
			this.maxNum = this.$route.query.num;
			this.giftType = this.$route.query.type;

			this.getBaseInfo();

			this.getAddressList(1, 1);
		},
		watch: {
			provId(n, o) {
				this.getAddressList(n, 2);
			},
			cityId(n, o) {
				this.getAddressList(n, 3);
			},
		},
		methods: {
			getBaseInfo() {
				this.$axios({
					url: "My/GiftExchangeEntityInfo",
					method: "post",
					data: {
						uid: this.uid,
						g_g_id: this.gid,
						type: this.giftType,
						g_nums: this.maxNum
					}
				}).then(res => {
					console.log(res);
					if(res.data.code == 200) {
						this.aid = res.data.data.address.a_id;
						this.addressName.provName = res.data.data.address.area[0];
						this.addressName.cityName = res.data.data.address.area[1];
						this.addressName.areaName = res.data.data.address.area[2];
						this.detailAddress = res.data.data.address.detailed_address;
						this.contactName = res.data.data.address.name;
						this.contactTel = res.data.data.address.tel;
						this.preArea = res.data.data.address.area[2];
						this.preDetailAdd = res.data.data.address.detailed_address;
						this.preName = res.data.data.address.name;
						this.preTel = res.data.data.address.tel;
						this.transFee = res.data.data.address.area[1] == "苏州市" ? 6 : 15;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getAddressList(id, type) {
				this.$axios({
					url: "Currency/getRegionInfoList",
					method: "post",
					data: {
						region_id: id
					}
				}).then(res => {
					console.log(res);
					if(res.data.code == 200) {
						if(type == 1) {
							this.addList.provList = res.data.data;
						} else if(type == 2) {
							this.addList.cityList = res.data.data;
						} else if(type == 3) {
							this.addList.areaList = res.data.data;
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			addNum() {
				if(this.exchangeNum < this.maxNum) {
					this.exchangeNum++;
				} else {
					this.exchangeNum = this.maxNum;
					this.$toast({
						message: "没那么多了~",
						position: "bottom",
						duration: 3000
					})
				}
			},
			delNum() {
				if(this.exchangeNum > 1) {
					this.exchangeNum--;
				} else {
					this.exchangeNum = 1;
					this.$toast({
						message: "不能再减了~",
						position: "bottom",
						duration: 3000
					})
				}
			},
			chooseAdd(id, name, type) {
				console.log(id, name, type)
				if(type == 1) {
					this.provId = id;
					this.addressName.provName = name;
					this.addressName.cityName = "";
					this.addressName.areaName = "";
					this.transFee = this.addressName.citName == "苏州市" ? 6 : 15;
					this.showAdd.prov = 0;
				} else if(type == 2) {
					this.cityId = id;
					this.addressName.cityName = name;
					this.addressName.areaName = "";
					this.transFee = name == "苏州市" ? 6 : 15;
					this.showAdd.city = 0;
				} else if(type == 3) {
					this.areaId = id;
					this.addressName.areaName = name;
					this.showAdd.area = 0;
				}
			},
			showProv() {
				this.showAdd.prov = 1;
			},
			showCity() {
				if(this.addList.cityList.length == 0) {
					this.showAdd.prov = 1;
				} else {
					this.showAdd.city = 1;
				}
			},
			showArea() {
				if(this.addList.areaList.length == 0) {
					if(this.addList.cityList.length == 0) {
						this.showAdd.prov = 1;
					} else {
						this.showAdd.city = 1;
					}
				} else {
					this.showAdd.area = 1;
				}
			},
			submitExchange() {
				let setDefaultAdd = Number(this.setAddress);
				if(this.addressName.areaName != this.preArea || this.detailAddress != this.preDetailAdd || this.contactName != this.preName || this.contactTel != this.preTel) {
					console.log("变了");
					this.aid = "";
				}
				let isSameCity = this.addressName.cityName == "苏州市" ? 1 : 2;

				console.log(setDefaultAdd, isSameCity, this.aid);
				if(!this.contactName) {
					this.$toast({
						message: "还没填写联系人姓名哦~",
						position: "bottom",
						duration: 2000
					});
					return false;
				} else if(!this.contactTel) {
					this.$toast({
						message: "还没填写联系人电话哦~",
						position: "bottom",
						duration: 2000
					});
					return false;
				} else if(!this.addressName.areaName) {
					this.$toast({
						message: "请选择收货地址~",
						position: "bottom",
						duration: 2000
					});
					return false;
				} else if(!this.detailAddress) {
					this.$toast({
						message: "请填写详细地址~",
						position: "bottom",
						duration: 2000
					});
					return false;
				}
				var _this = this;
				let data = {
					uid: this.uid,
					g_g_id: this.gid,
					type: this.giftType,
					g_nums: this.maxNum,
					remarks: this.remakes,
					city: isSameCity,
					a_id: this.aid,
					name: this.contactName,
					tel: this.contactTel,
					area: this.areaId,
					detailed_address: this.detailAddress,
					is_default: setDefaultAdd
				};
				this.$axios({
					url: "My/GiftExchangeEntity",
					method: "post",
					data: data,
				}).then(res => {
					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			hideAlert(){
				this.showAlert = 0
			},
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	.gift-exchange-wrap {
		padding-top: 2.5rem;
		padding-bottom: 3.5rem;
	}
	
	.top-banner img {
		width: 100%;
	}
	
	.form-wrap {
		background: #fff;
	}
	
	.form-wrap .title {
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		line-height: 1.5rem;
		padding: 0.5rem 1rem;
	}
	
	.form-list li {
		padding: 0.6rem 1rem;
		border-top: 1px solid #f3f3f3;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.form-list li .name {
		font-size: 0.8rem;
		color: #282828;
		width: 3.6rem;
		align-self: flex-start;
		padding: 0.4rem 0;
	}
	
	.form-list li:first-of-type input.nums {
		width: 2.5rem;
		height: 1.8rem;
		text-align: center;
		border: 0;
		outline: 0;
		border-left: 1px solid #4E05FF;
		border-right: 1px solid #4E05FF;
		color: #4E05FF;
	}
	
	.form-list li img {
		width: 0.8rem;
	}
	
	.form-list li:first-of-type .value {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #4E05FF;
		border-radius: 2rem;
		padding: 0 0.2rem;
		flex: 0;
	}
	
	.form-list li .value span {
		padding: 0 0.5rem;
	}
	
	.form-list li .value span:active {
		opacity: 0.7;
	}
	
	.form-list li .value {
		flex: 1;
	}
	
	.form-list li .value.add {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.form-list li .value.add>div {
		width: 30%;
		position: relative;
	}
	
	.form-list li .add-list {
		position: absolute;
		font-size: 0.8rem;
		color: #7b7b7b;
		background: #fff;
		text-align: center;
		width: 100%;
		border: 1px solid #f3f3f3;
		top: 100%;
		left: 0;
		max-height: 13.65rem;
		overflow-y: scroll;
		z-index: 10;
	}
	
	.form-list li .add-list p {
		line-height: 1.2rem;
		padding: 0.5rem 0;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.form-list li .add-list p:active {
		background: #fafafa;
	}
	
	.form-list li .value.add>div input {
		width: 100%;
		text-align: left;
	}
	
	.form-list li .value input {
		font-size: 0.8rem;
		width: 100%;
		height: 2rem;
		padding: 0 0.5rem;
		border: 0;
		outline: 0;
		background: none;
	}
	
	.form-list li .value textarea {
		font-size: 0.8rem;
		width: 100%;
		height: 4rem;
		padding: 0.2rem 0.5rem;
		line-height: 1.5rem;
		border: 0;
		outline: 0;
		background: none;
	}
	
	.form-list li:last-of-type .name {
		width: auto;
	}
	
	.form-list li:last-of-type .value {
		flex: 0;
	}
	
	.mint-switch-input:checked+.mint-switch-core {
		border-color: #5415F9;
		background-color: #5415F9;
		opacity: 0.3;
	}
	
	.form-submit {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		background: #fff
	}
	
	.form-submit button {
		background: linear-gradient(108deg, rgba(84, 21, 249, 0.4) 0%, rgba(84, 21, 249, 0.7) 100%);
		color: #fff;
		font-size: 0.9rem;
		padding: 1rem 1.5rem;
		border: 0;
		outline: 0;
	}
	
	.form-submit .form-price {
		padding-left: 1rem;
		font-size: 0.9rem;
		color: #282828;
	}
	
	.form-submit .form-price .num {
		font-size: 1.5rem;
		color: #5415F9;
		font-weight: bold;
	}
	
	.form-submit .form-price .num-name {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
	
	.form-submit .form-price .tip {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/GiftExchange.vue